import { get } from 'lodash-es';
import { handleActions } from 'redux-actions';

import { IDLE } from 'settings/constants/apiState';
import { appLogoutAction } from 'store/actions/app';
import { getAllTransactionFormProcessAction } from 'store/actions/formProcess';
import {
  getTransactionAction,
  getTransactionAgentsCoordinatorsAction,
  getKeyDatesAction,
  getFinancialPricingAction,
  updateKeyDatesAction,
  getTransactionClientAddressAction,
  updateTransactionAction,
  resetTransactionAction,
  createTransactionAction,
  createTransactionAction_,
  updateTransactionStatusAction,
  inviteTransactionParticipantAction,
  removeTransactionParticipantAction,
  updateTransactionMilestonesAction,
  deleteTransactionTaskAction,
  updateMilestoneStatusAction,
  uploadTransactionTaskDocumentsAction,
  updateTransactionTaskAction,
  createTransactionTaskAction,
  deleteTransactionTaskDocumentAction,
  createTransactionContactAction,
  getTransactionContactAction,
  getTransactionDetailsAction,
  getTasksForCancelledTransactionFrAction,
  updateUnReadNotesForTransactionAction,
  updateTransactionStatsAction,
  updateTransactionParticipantAccessAction,
} from 'store/actions/transactions';

const initialData = {
  state: IDLE,
  updateState: IDLE,
  data: null,
  meta: {},
  address: null,
  allTransactionFormProcesses: [],
  agentsCoordinators: {},
  clientAddress: {
    state: IDLE,
    data: [],
  },
  contacts: [],
  details: [],
  cancellationTasks: [],
  keyDates: {},
  financialPricing: [],
  stats: null,
};

export default handleActions(
  {
    [getTransactionAction]: (state, { payload }) => ({
      ...state,
      state: payload.state,
      data: get(payload, 'data.result', initialData.data),
      meta: get(payload, 'meta', initialData.meta),
      address: get(payload, 'data.result.Property.Address', state.address),
    }),
    [getKeyDatesAction]: (state, { payload }) => ({
      ...state,
      keyDates: get(payload, 'data.result', state.keyDates),
    }),
    [getTransactionAgentsCoordinatorsAction]: (state, { payload }) => ({
      ...state,
      agentsCoordinators: get(payload, 'data.result', state.agentsCoordinators),
    }),
    [getFinancialPricingAction]: (state, { payload }) => ({
      ...state,
      financialPricing: payload?.data?.result || [],
    }),
    [updateKeyDatesAction]: (state, { payload }) => ({
      ...state,
      keyDates: get(payload, 'data.result', state.keyDates),
    }),
    [getTasksForCancelledTransactionFrAction]: (state, { payload }) => ({
      ...state,
      cancellationTasks: get(payload, 'data.result', initialData.cancellationTasks),
    }),
    [getTransactionDetailsAction]: (state, { payload }) => ({
      ...state,
      details: get(payload, 'data.result', state.details),
    }),
    [getTransactionClientAddressAction]: (state, { payload }) => ({
      ...state,
      clientAddress: {
        state: payload.state,
        data: get(payload, 'data.result', initialData.clientAddress.data),
      },
    }),
    [createTransactionAction]: (state, { payload }) => ({
      ...state,
      state: payload.state,
      data: get(payload, 'data.result', initialData.data),
      meta: get(payload, 'meta', initialData.meta),
    }),
    [createTransactionAction_]: (state, { payload }) => ({
      ...state,
      state: payload.state,
      data: get(payload, 'data.result', initialData.data),
      meta: get(payload, 'meta', initialData.meta),
    }),
    [updateTransactionAction]: (state, { payload }) => ({
      ...state,
      updateState: payload.state,
      data: get(payload, 'data.result', state.data),
      meta: get(payload, 'meta', initialData.meta),
      address: get(payload, 'data.result.Property.Address', state.address),
    }),
    [deleteTransactionTaskDocumentAction]: (state, { payload }) => ({
      ...state,
      updateState: payload.state,
      data: get(payload, 'data.result', state.data),
      meta: get(payload, 'meta', initialData.meta),
    }),
    [inviteTransactionParticipantAction]: (state, { payload }) => {
      // Handle adding a new participant to the transaction
      const newParticipant = get(payload, 'data.result', null);
      const currentParticipants = state.data?.Participants || [];

      return {
        ...state,
        updateState: payload.state,
        data: {
          ...state.data,
          Participants: newParticipant
            ? [...currentParticipants, { ...newParticipant, ...newParticipant?.Participant }]
            : currentParticipants,
        },
        meta: get(payload, 'meta', initialData.meta),
      };
    },
    [updateTransactionStatusAction]: (state, { payload }) => {
      const Status = get(payload, 'data.result.Status', []);
      return {
        ...state,
        updateState: payload.state,
        data: {
          ...state.data,
          Status,
        },
        meta: get(payload, 'meta', initialData.meta),
      };
    },
    [removeTransactionParticipantAction]: (state, { payload }) => {
      // Get the removed participant ID
      const removedParticipantId = get(payload, 'data.result', null);

      if (!removedParticipantId) {
        return state;
      }

      // Filter out the removed participant
      const currentParticipants = state.data?.Participants || [];
      const updatedParticipants = currentParticipants.filter(
        (participant) => participant.Id !== removedParticipantId,
      );

      return {
        ...state,
        updateState: payload.state,
        data: {
          ...state.data,
          Participants: updatedParticipants,
        },
        meta: get(payload, 'meta', initialData.meta),
      };
    },
    [updateTransactionMilestonesAction]: (state, { payload }) => {
      // The backend now returns just the milestones array instead of the full transaction
      const milestones = get(payload, 'data.result', state.data.Milestones);
      return {
        ...state,
        updateState: payload.state,
        data: {
          ...state.data,
          Milestones: milestones,
        },
        meta: get(payload, 'meta', initialData.meta),
      };
    },
    [updateTransactionParticipantAccessAction]: (state, { payload }) => {
      // Handle updating a participant's access
      const updatedParticipant = get(payload, 'data.result', null);

      if (!updatedParticipant) {
        return state;
      }

      const currentParticipants = state.data?.Participants || [];
      const updatedParticipants = currentParticipants.map((participant) =>
        participant.Id === updatedParticipant.Id
          ? { ...participant, ...updatedParticipant }
          : participant,
      );

      return {
        ...state,
        updateState: payload.state,
        data: {
          ...state.data,
          Participants: updatedParticipants,
        },
        meta: get(payload, 'meta', initialData.meta),
      };
    },
    [updateMilestoneStatusAction]: (state, { payload }) => {
      // Get the updated milestone
      const updatedMilestone = get(payload, 'data.result', null);

      if (!updatedMilestone) {
        return state;
      }

      // Find and update the milestone in the current state
      const currentMilestones = state.data?.Milestones || [];
      const updatedMilestones = currentMilestones.map((milestone) =>
        milestone.Id === updatedMilestone.Id ? updatedMilestone : milestone,
      );

      return {
        ...state,
        data: {
          ...state.data,
          Milestones: updatedMilestones,
        },
        meta: get(payload, 'meta', initialData.meta),
      };
    },
    [deleteTransactionTaskAction]: (state, { payload }) => ({
      ...state,
      state: payload.state,
      data: get(payload, 'data.result', state.data),
      meta: get(payload, 'meta', initialData.meta),
    }),
    [uploadTransactionTaskDocumentsAction]: (state, { payload }) => ({
      ...state,
      data: get(payload, 'data.result', state.data),
      meta: get(payload, 'meta', initialData.meta),
    }),
    [createTransactionTaskAction]: (state, { payload }) => ({
      ...state,
      data: get(payload, 'data.result', state.data),
      meta: get(payload, 'meta', initialData.meta),
    }),
    [updateTransactionTaskAction]: (state, { payload }) => {
      // Get the updated task
      const updatedTask = get(payload, 'data.result', null);

      if (!updatedTask || !state.data) {
        return state;
      }

      // Update the specific task in the Tasks array
      const currentTasks = state.data?.Tasks || [];
      const updatedTasks = currentTasks.map((task) =>
        task.Id === updatedTask.Id ? updatedTask : task,
      );

      return {
        ...state,
        data: {
          ...state.data,
          Tasks: updatedTasks,
        },
        meta: get(payload, 'meta', initialData.meta),
      };
    },
    [resetTransactionAction]: (state) => ({
      ...initialData,
      address: get(state, 'address', state.address),
    }),
    [appLogoutAction]: () => initialData,
    [getAllTransactionFormProcessAction]: (state, { payload }) => ({
      ...state,
      state: payload?.state,
      allTransactionFormProcesses: get(
        payload,
        'data.value',
        initialData.allTransactionFormProcesses,
      ),
    }),
    [createTransactionContactAction]: (state, { payload }) => ({
      ...state,
      contacts: get(payload, 'data.result', state.contacts),
    }),
    [getTransactionContactAction]: (state, { payload }) => ({
      ...state,
      contacts: get(payload, 'data.result', state.contacts),
    }),
    [updateUnReadNotesForTransactionAction]: (state, { payload }) => {
      const { transactionId, userId } = payload;
      const updatedData = [...(state.data || [])];

      const transactionToUpdate = updatedData.find(
        (transaction) => transaction.Id === transactionId,
      );

      if (transactionToUpdate) {
        transactionToUpdate.Notes = (transactionToUpdate.Notes || []).map((note) => {
          note.MessageReceipts = (note.MessageReceipts || []).map((messageReceipt) => {
            if (messageReceipt.UserId === userId) {
              messageReceipt.IsRead = true;
            }
            return messageReceipt;
          });
          return note;
        });
      }

      return { ...state, data: updatedData };
    },
    [updateTransactionStatsAction]: (state, { payload }) => ({
      ...state,
      stats: payload,
    }),
  },
  initialData,
);
